export default "__VITE_ASSET__ZD2693vW__"